module.exports = __webpack_public_path__ + "img/publish.359ac460.svg";